import module from 'fan/proyecto/module.js'
import template from './template.html'
import placeholders from '../../placeholders.json'
import './style.scss'

export class FanProyectoDocumentosPlantillasAgregarComponent {
  constructor ($state) {
    this.$state = $state
    this.idProyecto = undefined
    this.guardando = false
    this.placeholders = placeholders
    this.data = {
      nombre: '',
      id_tipo_plantilla: 1,
      documento_contenido: '',
      documento_titulo: '',
      archivo_nombre: '',
      documento_logotipo: false,
      documento_margenes_encabezado: null,
      documento_numero_paginas: false
    }
  }

  actualizar (documento) {
    this.data.documento_contenido = documento.contenido
  }

  cerrar () {
    this.$state.go('^')
  }

  guardar (data) {
    this.guardando = false

    if (data) {
      this.$state.go('proyecto.documentos.plantilla', {id_plantilla: data.id_plantilla})
    }
  }
}

module.component('fanProyectoDocumentosPlantillasAgregar', {
  controller: FanProyectoDocumentosPlantillasAgregarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantillas/agregar/component.js